import React, { Component } from 'react'
import { Layout } from 'antd'
import '../../../App.css'
import SideBox from '../../cell/Side'
import * as images from './image'
import { withTranslation } from 'react-i18next'
const { Content, Sider } = Layout
class CommonProblemDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [
        {
          title: 'common_detail_title01',
          id: 1,
          content: [
            images.common01,
            images.common02,
            'detail_list0101',
            'detail_list0102',
            images.common03,
            images.common04,
            'detail_list0103',
            images.common05,
            'detail_list0104',
            images.iconRar,
            'detail_list0105',
            'detail_list0106',
            images.common06,
          ],
        },
        {
          title: 'common_detail_title02',
          content: ['detail_list0201', images.common0201],
          id: 2,
        },
        {
          title: 'common_detail_title03',
          content: [
            'detail_list0301',
            'detail_list0302',
            'detail_list0303',
            images.common0301,
            images.common0302,
            images.common0302,
          ],
          id: 3,
        },
        {
          title: 'common_detail_title04',
          content: [
            'detail_list0401',
            'detail_list0402',
            'detail_list0403',
            'detail_list0404',
            images.common0401,
            'detail_list0405',
            images.common0402,
          ],
          id: 4,
        },
        {
          title: 'common_detail_title05',
          content: [
            'detail_list0501',
            images.common0501,
            'detail_list0502',
            images.common0502,
            'detail_list0503',
            'detail_list0504',
            images.common0503,
          ],
          id: 5,
        },
        {
          title: 'common_detail_title06',
          content: [
            images.common0601,
            'detail_list0601',
            'detail_list0602',
            'detail_list0603',
            images.common0602,
            'detail_list0604',
          ],
          id: 6,
        },
      ],
    }
  }
  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search)
    var list = this.state.list.filter((item) => {
      return item.id === parseInt(params.get('type'))
    })
    this.setState({
      list: list,
    })
  }
  render() {
    const { t } = this.props
    return (
      <Content className="q-content-wrapper">
        <div className="q-main" style={{ padding: '65px' }}>
          <div className="q-fix-width ">
            <Layout>
              <Content className="q-detail-content q-content-border q-padding-50">
                {this.state.list.map((item) => (
                  <div className="" key={item.title + Math.random() * 10}>
                    <h1 className="headline">
                      <span className="icon icon-problem"></span>
                      <p>{t(item.title)}</p>
                    </h1>
                    <div className="headline_extra"></div>
                    <div className="q-detail_article">
                      {item.content.map((_item) =>
                        _item.slice(-3) === 'png' ||
                        _item.slice(0, 10) === 'data:image' ? (
                          <img
                            className="artcle-img"
                            style={{
                              width:
                                _item.slice(0, 10) === 'data:image'
                                  ? '20px'
                                  : '',
                            }}
                            key={_item + Math.random() * 10}
                            src={_item}
                            alt=""
                          />
                        ) : _item.slice(-3) === 'zip' ? (
                          <a key={_item + Math.random() * 10}>{t(_item)}</a>
                        ) : (
                          <p key={_item + Math.random() * 10}>{t(_item)}</p>
                        )
                      )}
                    </div>
                  </div>
                ))}
              </Content>
              <Sider theme="light" className="q-detail-sider">
                <SideBox type="2" />
              </Sider>
            </Layout>
          </div>
        </div>
      </Content>
    )
  }
}
export default withTranslation()(CommonProblemDetail)
